'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _reduxActions = require('./redux-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = {
    currentVideoNodeId: '',
    videos: {}
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _reduxActions.types.PLAY_VIDEO:
            {
                var startMode = action.meta.startMode;


                var newState = (0, _extends4.default)({}, state, {
                    currentVideoNodeId: action.payload,
                    currentVideoStartMode: startMode
                });

                if (startMode !== 'silent') {
                    newState.currentNonSilentVideoNodeId = action.payload;
                }

                return newState;
            }
        case _reduxActions.types.RECEIVE_VIDEO:
            return (0, _extends4.default)({}, state, {
                videos: (0, _extends4.default)({}, state.videos, (0, _defineProperty3.default)({}, action.meta.id, action.payload))
            });
        default:
            return state;
    }
}
//# sourceMappingURL=redux-reducer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/video-asset/lib/cjs/redux-reducer.js
 ** module id = 708
 ** module chunks = 1
 **/